import { useEffect } from 'react';
import { StatusBar, Style } from '@capacitor/status-bar';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

/**
 * Hook to initialize Capacitor plugins on app start
 */
export const useCapacitorInit = () => {
  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    const initializeCapacitor = async () => {
      try {
        // Initialize status bar with iOS glass effect
        await StatusBar.setStyle({ style: Style.Light });
        await StatusBar.setOverlaysWebView({ overlay: true });

        // Log app state changes
        App.addListener('appStateChange', ({ isActive }) => {
          console.log('App state changed. Is active:', isActive);
        });

        // Handle app URL open events
        App.addListener('appUrlOpen', (event) => {
          console.log('App opened with URL:', event.url);
        });

        console.log('Capacitor initialized successfully');
      } catch (error) {
        console.log('Capacitor initialization error:', error);
      }
    };

    initializeCapacitor();

    return () => {
      // Cleanup listeners on unmount
      App.removeAllListeners();
    };
  }, []);

  return {
    isNativePlatform: Capacitor.isNativePlatform()
  };
};